module.exports = __webpack_public_path__ + "img/auto-flak.58c589be.png";